import { useParams } from 'react-router-dom';
import { RegisterForm } from './RegisterForm';

export const Register = () => {
  let { ev_id } = useParams();
  return (
    <>
      <div className="breadcrumb-banner-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb-text">
                <h1 className="text-center">Registro</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-form-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h4 className="contact-title">
                ¡Regístrate para recibir constancia de asistencia!
              </h4>
              <RegisterForm ev_id={ev_id} />
              <p className="form-messege">
                * Verifica tu nombre y apellidos ya que así aparecerá en la
                constancia de asistencia
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
